import React from 'react';
import { Button, Col, Input, Row, Form } from 'antd';

export const ElectricMeteringPointFilter = ({ t, onFilter, isUserAdmin }) => {
  const [form] = Form.useForm();

  const onClear = () => {
    form.resetFields();
    onFilter?.({});
  };

  const onFinish = (values) => {
    onFilter?.(values);
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            name="eiczCode"
            label={t('filter.eicz')}
            hasFeedback={false}
          >
            <Input placeholder={t('filter.eiczPlaceholder')} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="consumer"
            label={t('filter.consumer')}
            hasFeedback={false}
          >
            <Input placeholder={t('filter.consumerPlaceholder')} />
          </Form.Item>
        </Col>
        <Col span={8}>
          {isUserAdmin && (
            <Form.Item
              name="loadingOperator"
              label={t('filter.loadingOperator')}
              hasFeedback={false}
            >
              <Input placeholder={t('filter.loadingOperatorPlaceholder')} />
            </Form.Item>
          )}
        </Col>
      </Row>
      <div className={'component-form-actions'}>
        <Button onClick={onClear}>{t('filter.clearBtn')}</Button>
        <Button type="primary" htmlType="submit">
          {t('filter.submitBtn')}
        </Button>
      </div>
    </Form>
  );
};
